import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { registerUser, loginUser } from "../actions/authActions";
import pageTransition from "../utils/pageTransition";
import classnames from "classnames";
import ReactCardFlip from "react-card-flip";
import {
  FaSignInAlt,
  FaChartLine,
  FaClock,
  FaServer,
  FaTimes,
  FaLock,
  FaUserPlus,
  FaCheck,
  // FaExclamationCircle,
} from "react-icons/fa";
import $ from "jquery";
import SimpleReactValidator from "simple-react-validator";
const isEmpty = require("is-empty");

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      s_email: "",
      s_password: "",
      s_password2: "",
      fname: "",
      l_email: "",
      l_password: "",
      errors: {},
      login: true,
      signup: false,
      isLoggedIn: false,
      currentUser: "",
      isFlipped: false,
      showLoader: false,
      mobile: false,
      loginSuccess: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      messages: {
        in: "The passwords do not match",
      },
    });
  }

  componentDidMount() {
    axios.get("https://trend-backend.herokuapp.com/api/users/").then((res) => {
      console.log(res.data);
    });
    // If logged in and user navigates to landing page, should redirect them to dashboard
    if (this.props.auth.isAuthenticated) {
      this.props.history.push("/dashboard");
    }
    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  }

  componentDidUpdate(prevProps, props) {
    if (prevProps.auth.isAuthenticated) {
      this.props.history.push("/dashboard");
    }
    if (props.errors !== prevProps.errors) {
      this.setState({
        errors: prevProps.errors,
      });
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  checkCreds = async (e, attemptLogin) => {
    e.preventDefault();
    const userData = {
      email: this.state.l_email,
      password: this.state.l_password,
    };
    if (
      this.validator.fieldValid("email") ||
      this.validator.fieldValid("password")
    ) {
      $(".overlay").fadeIn();
      $(".loading-text").text("Validating Credentials...");
      await this.props.loginUser(userData);
      setTimeout(() => {
        this.attemptLogin();
      }, 500);
    } else {
      $(".text-danger_l").css("display", "block");
      this.validator.showMessages();
      this.forceUpdate();
      setTimeout(() => {
        $(".text-danger_s").css("display", "none");
        $(".text-danger_l").addClass("animate__animated animate__fadeIn");
      }, 100);
    }
  };

  attemptLogin = async (e) => {
    $("body").css("overflow-y", "hidden !important");
    setTimeout(() => {
      $("body").css("overflow-y", "scroll !important");
      if (this.props.auth.isAuthenticated == true) {
        $(".spinner-check").css("display", "unset");
        $(".spinner-lock").css("display", "none");
        $(".loading-text").text("Success!").finish();
        $(".loading-text").stop(true, true);
        setTimeout(() => {
          $(".overlay").fadeOut();
          $(".l_invalid").removeClass("animate__animated animate__fadeIn");
          $(".l_invalid").css("display", "none");
          setTimeout(() => {
            pageTransition();
            setTimeout(() => {
              this.props.history.push("/dashboard");
            }, Math.floor(Math.random() * (3000 - 1500 + 1) + 1500));
          }, 300);
        }, 500);
      } else {
        $(".overlay").fadeOut();
        $(".l_invalid").addClass("animate__animated animate__fadeIn");
      }
    }, 1200);
  };

  onSubmit_newUser = async (e) => {
    e.preventDefault();
    const newUser = {
      name: this.state.fname,
      email: this.state.s_email,
      password: this.state.s_password,
      password2: this.state.s_password2,
    };

    if (
      this.validator.fieldValid("email") ||
      this.validator.fieldValid("name") ||
      this.validator.fieldValid("password") ||
      this.validator.fieldValid("password2")
    ) {
      await this.props.registerUser(newUser, this.props.history);
      this.setState({ errors: {} });
      const { errors } = this.state;
      $(".overlay").fadeIn();
      $("body").css("overflow-y", "hidden !important");
      $(".loading-text").text("Creating Account...");

      setTimeout(() => {
        $(".overlay").fadeOut();
        $("html").css("overflow-y", "scroll !important");
        setTimeout(() => {
          if (isEmpty(this.state.errors)) {
            $("#signup_form")[0].reset();
            this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
            $(".active").removeClass("slide");
            $(".active").addClass("slide-back");
            this.setState({ login: true });
            $(".signupform").css("display", "none");
            $(".loginform").css("display", "block");
            setTimeout(() => {
              $(".loginsuccess").css("display", "block");
              $(".loginsuccess").addClass("animate__animated animate__fadeIn");
            }, 500);
          } else {
            $(".s_invalid").css("display", "block");
            $(".s_invalid").addClass("animate__animated animate__fadeIn");
            $(".s_invalid").css("opacity", "1");
            if (!$("#s_email").hasClass("invalid")) {
              $(".s_invalid").removeClass("animate__animated animate__fadeIn");
              $(".s_invalid").css("display", "none");
            }
          }
        }, 300);
      }, 1500);
    } else {
      $(".text-danger_s").css("display", "block");
      this.validator.showMessages();
      this.forceUpdate();
      setTimeout(() => {
        $(".text-danger_s").addClass("animate__animated animate__fadeIn");
        $(".text-danger_l").css("display", "none");
      }, 100);
    }
  };

  showLogin = () => {
    $(".loginform").css("display", "block");
    $(".active").removeClass("slide");
    $(".active").addClass("slide-back");
    this.setState({ login: true });
    setTimeout(() => {
      this.setState({ signup: false });
      $(".signupform").css("display", "none");
    }, 200);
  };

  showSignUp = () => {
    $(".signupform").css("display", "block");
    $(".active").removeClass("load");
    $(".active").removeClass("slide-back");
    $(".active").addClass("slide");
    this.setState({ login: false, signup: true });
    setTimeout(() => {
      $(".loginform").css("display", "none");
    }, 200);
  };

  handleClick(int) {
    if (int == 2 && this.state.login == true) {
      this.showSignUp();
      this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
    } else if (this.state.login == false && int == 1) {
      this.showLogin();
      this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
    }
  }

  render() {
    const { errors } = this.state;
    return (
      <main>
        <div className="main-wrapper">
          <div className="half left">
            <div className="half-content">
              <div className="logo-container">
                <img alt="logo" src={require("../img/logo.png")} />
              </div>
              <h2>Welcome to Trend.</h2>
              <p>
                A real-time investment tracking platform. <br />
                Please log in or <span>register</span> to get started!
              </p>
              <ul>
                <li>
                  <FaChartLine /> Tracks 4000+ companies and 3000+ currency
                  exchanges
                </li>
                <li>
                  <FaClock /> Real-time profits and pricing
                </li>
                <li>
                  <FaServer /> Historical data including day-end pricing and
                  52-week visualizations to give you the knowledge to maximize
                  your returns
                </li>
              </ul>
            </div>
          </div>
          <div className="half right">
            <div className="desktop-overlay">
              <div className="overlay">
                <FaLock className="spinner-lock" />
                <FaCheck className="spinner-check" />
                <br />
                <span className="loading-text"></span>
              </div>
            </div>
            <div className="login-container">
              <div className="modal">
                <ReactCardFlip
                  isFlipped={this.state.isFlipped}
                  flipDirection="horizontal"
                >
                  <div className="modal-content" id="login-content">
                    <div className="hdr-text">
                      <div className="form-switch">
                        <span
                          className="login"
                          onClick={() => {
                            this.handleClick(1);
                          }}
                        >
                          Login
                        </span>
                        <span
                          className="signup"
                          onClick={() => {
                            this.handleClick(2);
                          }}
                        >
                          Sign Up
                        </span>
                        <span className="active load"> </span>
                      </div>
                    </div>
                    <div className="loginform">
                      <div className="mobile-overlay">
                        <div className="overlay">
                          <FaLock className="spinner" />
                          <br />
                          <span className="loading-text"></span>
                        </div>
                      </div>
                      <h2>Login</h2>
                      <span className="l_invalid">
                        <FaTimes />
                        Invalid email or password
                      </span>
                      <span className="loginsuccess">
                        Successfully created account! Please sign in to
                        continue.
                      </span>
                      <form
                        encType="multipart/form-data"
                        noValidate
                        id="login_form"
                        onSubmit={this.checkCreds}
                      >
                        <label> Email</label>

                        <input
                          onChange={this.onChange}
                          value={this.state.l_email}
                          error={errors.email}
                          id="l_email"
                          type="email"
                          className={classnames("", {
                            invalid: errors.email || errors.emailincorrect,
                          })}
                        />

                        {this.validator.message(
                          "email",
                          this.state.l_email,
                          "required|email",
                          { className: "text-danger_l l_email" }
                        )}

                        <label> Password</label>
                        <input
                          type="text"
                          onChange={this.onChange}
                          value={this.state.l_password}
                          error={errors.password}
                          id="l_password"
                          type="password"
                          className={classnames("", {
                            invalid:
                              errors.password || errors.passwordincorrect,
                          })}
                        />
                        {this.validator.message(
                          "password",
                          this.state.l_password,
                          "required",
                          { className: "text-danger_l l_password" }
                        )}

                        <p className="forgot">
                          Forgot email or password? <span>Click here!</span>
                        </p>

                        <button className="submitBtn" type="submit">
                          Login <FaSignInAlt />
                        </button>
                      </form>
                    </div>
                  </div>

                  <div className="modal-content" id="signup-content">
                    <div className="hdr-text">
                      <div className="form-switch">
                        <span
                          className="login"
                          onClick={() => {
                            this.handleClick(1);
                          }}
                        >
                          Login
                        </span>
                        <span
                          className="signup"
                          onClick={() => {
                            this.handleClick(2);
                          }}
                        >
                          Sign Up
                        </span>
                        <span className="active load"> </span>
                      </div>
                    </div>

                    <div className="signupform">
                      <div className="mobile-overlay">
                        <div className="overlay">
                          <FaLock className="spinner" />
                          <br />
                          <span className="loading-text"></span>
                        </div>
                      </div>
                      <h2>Sign Up</h2>
                      {this.state.signup ? (
                        <form
                          encType="multipart/form-data"
                          noValidate
                          onSubmit={this.onSubmit_newUser}
                          id="signup_form"
                        >
                          <label>Full name</label>
                          <input
                            onChange={this.onChange}
                            value={this.state.fname}
                            error={errors.name}
                            id="fname"
                            type="name"
                            className={classnames("", {
                              invalid: errors.name || errors.nameincorrect,
                            })}
                          />
                          {this.validator.message(
                            "name",
                            this.state.fname,
                            "required|string",
                            { className: "text-danger_s name" }
                          )}

                          <label> Email</label>
                          <input
                            onChange={this.onChange}
                            value={this.state.s_email}
                            error={errors.email}
                            id="s_email"
                            type="email"
                            className={classnames("", {
                              invalid: errors.email || errors.emailincorrect,
                            })}
                          />
                          {this.validator.message(
                            "email",
                            this.state.s_email,
                            "required|email",
                            { className: "text-danger_s s_email" }
                          )}

                          <label> Password</label>
                          <input
                            onChange={this.onChange}
                            value={this.state.s_password}
                            error={errors.s_password}
                            id="s_password"
                            type="password"
                            className={classnames("", {
                              invalid:
                                errors.password || errors.passwordincorrect,
                            })}
                          />
                          {this.validator.message(
                            "password",
                            this.state.s_password,
                            "required|min:6|max:30",
                            { className: "text-danger_s  s_password" }
                          )}
                          <label> Confirm Password</label>
                          <input
                            onChange={this.onChange}
                            value={this.state.s_password2}
                            error={errors.s_password2}
                            id="s_password2"
                            type="password"
                            className={classnames("", {
                              invalid:
                                errors.password2 || errors.password2incorrect,
                            })}
                          />
                          {this.validator.message(
                            "confirm password",
                            this.state.s_password2,
                            `required|in:${this.state.s_password}`,
                            { className: "text-danger_s s_password2" }
                          )}
                          <span className="s_invalid">
                            Email already exists!
                          </span>
                          <button className="submitBtn" type="submit">
                            Sign Up <FaUserPlus />
                          </button>
                        </form>
                      ) : null}
                    </div>
                  </div>
                </ReactCardFlip>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}
Login.propTypes = {
  loginUser: PropTypes.func.isRequired,
  registerUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { registerUser, loginUser })(
  withRouter(Login)
);
